import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * A filter in force (decision 101): it says what it filters by and removes itself with its own ×,
 * as Linear's filter tokens do. The × is a real button named after the filter it removes.
 */
export function FilterChip({
  label,
  value,
  onRemove,
}: {
  readonly label: string;
  readonly value: string;
  readonly onRemove: () => void;
}) {
  const { t } = useTranslation('common');
  return (
    <span className="filter-chip">
      <span>
        {label}: <strong>{value}</strong>
      </span>
      <button
        type="button"
        className="filter-chip-remove"
        aria-label={t('list.remove', { label, value })}
        onClick={onRemove}
      >
        <X aria-hidden="true" className="size-3.5" />
      </button>
    </span>
  );
}
